import { JSONUtils } from '../../../../utility/json-utils.js';
import { MapUtils } from '../../../../utility/map-utils.js';
import {
  cloneData, cloneList, isSameData, isSameList,
} from '../../../dto/data-model-utils.js';
import {
  SerializedData, SerializationContext,
  DataModelBuilder,
} from '../../../dto/data-model.js';
import { OpenAccessPass } from '../../open-access-pass/open-access-pass.js';
import { AuditLogEntryType } from '../audit-log-entry-type.js';
import { AuditLogEntry } from '../audit-log-entry.js';

export class OpenAccessPassModifiedEventsEntry extends AuditLogEntry {
  static readonly TYPE_ID: string = 'dac9e38057554c34a49257d7658af599';

  private constructor(
    public readonly before: OpenAccessPass,
    public readonly after: OpenAccessPass,
    public readonly addedEvents: string[],
    public readonly removedEvents: string[],
  ) {
    super();
  }

  get $typeId(): string {
    return OpenAccessPassModifiedEventsEntry.TYPE_ID;
  }

  generateQueryData(): SerializedData {
    return {
      businessRef: this.after.businessRef.encode(),
      passId: this.after.uniqueId,
      orderId: this.after.orderId,
    };
  }

  get type(): AuditLogEntryType {
    return AuditLogEntryType.EventOpenAccessPassModifiedEvents;
  }

  static create(args: {
    before: OpenAccessPass,
    after: OpenAccessPass,
    addedEvents: string[],
    removedEvents: string[],
  }): OpenAccessPassModifiedEventsEntry {
    return new OpenAccessPassModifiedEventsEntry(
        args.before,
        args.after,
        args.addedEvents,
        args.removedEvents,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): OpenAccessPassModifiedEventsEntry {
    return this.create({
      before: context.fromData<OpenAccessPass>(MapUtils.getRecord(map, 'before')),
      after: context.fromData<OpenAccessPass>(MapUtils.getRecord(map, 'after')),
      addedEvents: MapUtils.getList<string>(
          map,
          'addedEvents',
          (data) => JSONUtils.decodeString(data)),
      removedEvents: MapUtils.getList<string>(
          map,
          'removedEvents',
          (data) => JSONUtils.decodeString(data)),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      before: context.toData(this.before),
      after: context.toData(this.after),
      addedEvents: this.addedEvents,
      removedEvents: this.removedEvents,
    };
  }

  clone(): this {
    return OpenAccessPassModifiedEventsEntry.create({
      before: cloneData(this.before),
      after: cloneData(this.after),
      addedEvents: cloneList(this.addedEvents),
      removedEvents: cloneList(this.removedEvents),
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameData(other.before, this.before) &&
      isSameData(other.after, this.after) &&
      isSameList(other.addedEvents, this.addedEvents) &&
      isSameList(other.removedEvents, this.removedEvents);
  }
}

export class OpenAccessPassModifiedEventsEntryBuilder extends DataModelBuilder<OpenAccessPassModifiedEventsEntry> {
  build(context: SerializationContext, map: SerializedData): OpenAccessPassModifiedEventsEntry {
    return OpenAccessPassModifiedEventsEntry.fromMap(context, map);
  }
}
